import { isAdmin, authToken } from "../stores/stores";
import { urls, strings } from "../constants/strings";
import { Toast } from "spaper";

export const showErrorThenCallback = (errorMessage, callback) => {
  setTimeout(callback, 2500);
  Toast.danger(errorMessage);
};

export const loadAdoptableInfo = (id, kind) => {
  return urlGet(`${urls.api.getAdoptableInfo}?_id=${id}&kind=${kind}`);
};

export const deleteAdoptable = (id, kind) => {
  let formData = new FormData();
  formData.append("_id", id);
  formData.append("kind", kind);
  return urlPost(urls.api.deleteAdoptable, formData);
};

export const getAdoptables = (filters) => {
  return urlGet(`${urls.api.getAdoptables}?${filters}`);
};

export const updateAdoptableInfo = (data) => {
  return urlPost(urls.api.updateAdoptable, data);
};

export const registerAdoptable = (data) => {
  return urlPost(urls.api.registerAdoptable, data);
};

export const uploadAdoptionRequest = (data) => {
  return urlPost(urls.api.uploadAdoptionRequest, data);
};

export const updateAdoptionRequest = (id, attended) => {
  let formData = new FormData();
  formData.append("_id", id);
  formData.append("attended", attended);
  return urlPost(urls.api.updateAdoptionRequest, formData);
};

export const deleteAdoptionRequest = (id) => {
  let formData = new FormData();
  formData.append("_id", id);
  return urlPost(urls.api.deleteAdoptionRequest, formData);
};

export const getAdoptionRequests = (filters) => {
  if (filters) {
    return urlGet(`${urls.api.getAdoptionRequests}?${filters}`);
  }
  return urlGet(urls.api.getAdoptionRequests);
};

export const adminLogin = (loginData) => {
  return urlPost(urls.api.adminLogin, loginData, true);
};

const urlGet = (url) => {
  return _callApiEndpoint("GET", url);
};

const urlPost = (url, postData, expectHeaders = false) => {
  return _callApiEndpoint("POST", url, postData, expectHeaders);
};

let setHeaders = false;
let bearer = "";
authToken.subscribe(val => bearer = val);
isAdmin.subscribe(val => setHeaders = val);

const _callApiEndpoint = (method, url, data, expectHeaders) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open(method, url);
    if (setHeaders) {
      xhr.setRequestHeader("Authorization", `Bearer ${bearer}`)
    }
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 400) {
        if (expectHeaders) {
          const respHeader = xhr.getResponseHeader(strings.authTokenHeader);
          let response = JSON.parse(xhr.responseText);
          response[strings.authTokenHeader] = respHeader;
          resolve(response);
        } else {
          resolve(JSON.parse(xhr.responseText));
        }
      } else if (xhr.status === 403) { // Invalid token or session expired
        isAdmin.set(false);
        reject(strings.genericMessages.error.sessionExpired);
      }
      else {
        reject(strings.genericMessages.error.serverError);
      }
    };
    xhr.onerror = () => {
      reject(strings.genericMessages.error.connectionError);
    };
    if (method === "POST") {
      xhr.send(data);
    } else {
      xhr.send();
    }
  });
};